import $ from 'jquery';
import 'jquery-ui/ui/widgets/autocomplete';

export default function manualReassigning() {
  $('#added_user_data').autocomplete({
    source: $('#added_user_data').data('autocomplete-source')
  });

  // Handle change event for removed_user_id
  const removedUserId = document.getElementById('removed_user_id');
  const removedUserStatus = document.getElementById('removed_user_status');
  const removedUserComment = document.getElementById('removed_user_comment');

  removedUserId.addEventListener('change', function() {
    const isEmpty = this.value === '';
    removedUserStatus.disabled = isEmpty;
    removedUserComment.disabled = isEmpty;
  });
};